type QuickCardProps = {
  children?: any;
  className?: string;
};

const QuickCard = ({ children, className }: QuickCardProps) => {
  return (
    <div className={` flex items-center gap-1 lg:gap-3 w-[210px] scale-[45%] sx:scale-75 lg:scale-100 xl:scale-125 xl:left-6 sx:right-6 lg:right-0 relative right-14 ${className}`}>
      {children}
    </div>
  );
};

export default QuickCard;
